import React from "react";
import { Link } from "react-router-dom";
import { BlogType } from "../../../Types/types";
import { format } from "date-fns";

interface BlogProps {
  blog: BlogType;
}

// const delBlog = async (
//   blogId: string,
//   setBlogs: React.Dispatch<React.SetStateAction<BlogType[]>>
// ) => {
//   if (!window.confirm("Are you sure you want to delete this blog?")) {
//     return;
//   }

//   try {
//     const response = await deleteBlog(blogId);
//     console.log(response)
//     if (response.status === false) {
//       console.log("Job deletion failed:", response.response?.data.message);
//     } else {
//       setBlogs((prevBlogs) => prevBlogs.filter((blog) => blog._id !== blogId));
//       console.log("Blog deleted successfully:");
//       toast.success("Blog deleted successfully");
//     }
//   } catch (error) {
//     toast.error("Error deleting Blog");
//     console.error("Error deleting Blog:", error);
//   }
// };

const Blog = ({
  blog,
}: BlogProps) => {
  return (
    <div className="relative w-full">
      <Link
        to={`/blog/${blog.slug}`}
        state={{ blog }}
        onClick={() => window.scrollTo(0, 0)}
        className="w-full"
      >
        <div className="flex flex-col sm:flex-row gap-5 overflow-hidden p-5 bg-white rounded-3xl w-full">
          <img
            className="h-full w-full sm:w-[200px] sm:h-[200px] object-cover hover:scale-105 transition-all duration-300 rounded-2xl"
            src={`https://admin.techqilla.com${blog.image.url}`}
            alt={blog.imageAlt}
          />
          <div className="sm:py-4">
            <div className="mb-2 text-sm font-semibold text-primary">
              {blog.author} • {format(new Date (blog.createdAt), "dd MMM yyyy")}
            </div>
            <div className=" mb-2 justify-between cursor-pointer  apply underline-offset-4  transition-all duration-400">
              <p className="text-xl transition-all duration-400 montserrat-semibold sm:mb-2">
                {blog.title.split(" ").slice(0,8).join(" ")}...
              </p>
              <p className="montserrat-regular">{blog.description.split(" ").slice(0,10).join(" ")}...</p>
              <div className="hover:scale-110 flex gap-4 items-center text-primary origin-left transition-all duration-500">
                Read More{" "}
                <svg
                  className="text-2xl transition-all duration-300 rotate-45"
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="18"
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path
                    d="M7.33337 17L17.3334 7M17.3334 7H7.33337M17.3334 7V17"
                    stroke="#4D20FF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default Blog;
